import duimg from "../assets/onlydriver.JPG";
import iimg from "../assets/driversandrider.JPG";
import hbg from "../assets/9trorideandrider.JPG";
import pimg from "../assets/payment.jpg";
import backgroundssvg from "../assets/bgpng.svg";
import nitroridelogo from "../assets/logo.svg";
import applogo from "../assets/applelogo.svg";
import playlogo from "../assets/playstorelogo.svg";
import headerimg from "../assets/headerimage.svg";
import applogoblack from "../assets/appleblack.svg";
import menuo from "../assets/menuopen.svg";
import menuc from "../assets/menuclose.svg";
import rideimg1 from "../assets/rideimage1.svg";
import rideimg2 from "../assets/safeamount.svg";
import rideimg3 from "../assets/coinbalanceimg.svg";
import deliveryimg1 from "../assets/deliveriesimg.svg";
import deliveryimg2 from "../assets/deliveriesimg2.svg";
import foodimg1 from "../assets/foodimg1.svg";
import foodimg2 from "../assets/foodimg2.svg";
import earningimg1 from "../assets/earning.svg";
import earningimg2 from "../assets/earningimg2.svg";
import forwardicon from "../assets/forwardicon.svg";
import livetrackingimg from "../assets/livetracking.svg";
import logowhite from "../assets/logowhite.svg";
import fimg from "../assets/f.svg";
import igimg from "../assets/ig.svg";
import inimg from "../assets/in.svg";
import ximg from "../assets/x.svg";
import foodimg from "../assets/foodbg.png";
import dman from "../assets/deliveryman.svg";
import fkitchen from "../assets/fromkitchen.svg";
import ffood from "../assets/phonefood.svg";
import ord1 from "../assets/order1.svg";
import ord2 from "../assets/order2.svg";
import ord3 from "../assets/order3.svg";
import rcook from "../assets/readycook.svg";
import bi1 from "../assets/b1.svg";
import bi2 from "../assets/b2.svg";
import bi3 from "../assets/b3.svg";
import whyi1 from "../assets/why1.svg";
import whyi2 from "../assets/why2.svg";
import whyi3 from "../assets/why3.svg";
import whyi4 from "../assets/why4.svg";
import whyi5 from "../assets/why5.svg";
import driverbgimg from "../assets/driverbg.png";
import bci1 from "../assets/bc1.svg";
import bci2 from "../assets/bc2.svg";
import bci3 from "../assets/bc3.svg";
import wdi1 from "../assets/wd1.svg";
import wdi2 from "../assets/wd2.svg";
import economyimg from "../assets/economy.png";
import firstclassimg from "../assets/firstclass.png";
import luxuryimg from "../assets/luxury.png";
import motorcycleimg from "../assets/motorcycle.png";
import truckimg from "../assets/truck.png";
import bicycleimg from "../assets/bicycle.png";
import drivercarimg from "../assets/drivercar.png";
import locationpickupimg from "../assets/locationpickup.svg";
import locationdropoffimg from "../assets/locationdropoff.svg";
import drunkdriverimg from "../assets/drunkdriver.png";



export const driverbg = driverbgimg;
export const bci1img = bci1;
export const bci2img = bci2;
export const bci3img = bci3;
export const wdi1img = wdi1;
export const wdi2img = wdi2;


export const bi1img = bi1;
export const bi2img = bi2;
export const bi3img = bi3;

export const why1img = whyi1;
export const why2img = whyi2;
export const why3img = whyi3;
export const why4img = whyi4;
export const why5img = whyi5;


export const readycook = rcook;

export const order1 = ord1;
export const order2 = ord2;
export const order3 = ord3;

export const deliverymanimg = dman;
export const fromkitchen = fkitchen;
export const phonefood = ffood;

export const driveruserimg = duimg;
export const inbusinessimg = iimg;
export const headerbg = hbg;
export const paymentimg = pimg;
export const backgroundsvg = backgroundssvg;
export const nitrologo = nitroridelogo;
export const applestore = applogo;
export const playstore = playlogo;
export const headerimage = headerimg;
export const applestoreblack = applogoblack;
export const menuopen = menuo;
export const menuclose = menuc;
export const rideimage1 = rideimg1;
export const rideimage2 = rideimg2;
export const rideimage3 = rideimg3;
export const deliveryimage1 = deliveryimg1;
export const deliveryimage2 = deliveryimg2;
export const foodimage1 = foodimg1;
export const foodimage2 = foodimg2;
export const earningimage1 = earningimg1;
export const earningimage2 = earningimg2;
export const forwardiconimg = forwardicon;
export const livetrackingimage = livetrackingimg;
export const nitrologowhite = logowhite;
export const f = fimg;
export const ig = igimg;
export const inimage = inimg;
export const x = ximg;
export const foodbg = foodimg;
export const economy = economyimg;
export const firstclass = firstclassimg;
export const luxury = luxuryimg;
export const motorcycle = motorcycleimg;
export const truck = truckimg;
export const bicycle = bicycleimg;
export const drivercar = drivercarimg;
export const locationpickup = locationpickupimg;
export const locationdropoff = locationdropoffimg;
export const drunkdriver = drunkdriverimg;
